import { render, staticRenderFns } from "./MyIP.vue?vue&type=template&id=c27731ee&"
import script from "./MyIP.ts?vue&type=script&lang=ts&"
export * from "./MyIP.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports